
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default is localStorage
import DealReview from "./slices/DealReview";
import authReducer from "./slices/UserDetails";
import legalDetailsReducer from "./slices/LegalDetailsSlice";
import themeReducer from "./slices/themeSlice";
import overviewReducer from "./slices/OverviewSlice";
import breadcrumbsReducer from "./slices/BreadCrumbsSlice";
import staffingReducer from "./slices/StaffingSlice";
import loadingReducer from "./slices/loadingSlice";
import permissionReducer from "./slices/PermissionSlice";
import broadcastMiddleware from "./middleware/broadcastMiddleware";

// Configure persist config for slices you want to store in localStorage
const localStorageConfig = {
  key: "root", // You can customize the key if needed
  storage: storage,
  whitelist: ["currentUser", "theme", "breadcrumbs", "legalDetails","permission"], // Slices you want to store in localStorage
};

// Combine reducers with persist reducers
const rootReducer = combineReducers({
  dealsAndRole: DealReview,
  currentUser: authReducer,
  legalDetails: legalDetailsReducer,
  theme: themeReducer,
  overview: overviewReducer,
  breadcrumbs: breadcrumbsReducer,
  staffing: staffingReducer,
  loader: loadingReducer,
  permission: permissionReducer,
  // other reducers...
});

const persistedReducer = persistReducer(localStorageConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Suppress redux-persist serialization warnings for its own action types
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(broadcastMiddleware),
});

export const persistor = persistStore(store);
